"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNearbyProperties = void 0;
var React = require("react");
var format_1 = require("@/utils/format");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var renderNearbyProperties = function (props) {
    var renderPropertyItem = function (it, i) {
        var onNearbyItemClick = function () { return props.onNearbyItemClick(it, i); };
        var onNearbyItemShow = function (e) {
            e.stopPropagation();
            props.onNearbyItemShow(it, i);
        };
        var price = it.price > 0
            ? (it.type === SfilterTypeGroup_1.SfilterType.BUY || SfilterTypeGroup_1.SfilterType.BUYRENT
                ? format_1.default.currencySale(it.price, props.langCode, props.symbol)
                : format_1.default.currencyLease(it.price, props.langCode, props.symbol))
            : props.t.subjectToOffer;
        return (React.createElement("div", { style: { cursor: 'pointer' }, onClick: onNearbyItemClick, key: i, className: "c-propsmsimilar__item" },
            React.createElement("div", { className: "c-propsmsimilar__img" },
                React.createElement("img", { src: it.image, alt: it.name })),
            React.createElement("div", { className: "c-propsmsimilar__info" },
                React.createElement("div", { className: "c-propsmsimilar__name" }, it.name),
                React.createElement("div", { className: "c-propsmsimilar__price" }, price),
                React.createElement("div", { className: "c-propsmsimilar__size" },
                    React.createElement("div", { className: "c-propsmsimilar__sizegroup" },
                        React.createElement("div", { className: "c-propsmsimilar__sizevalue" }, format_1.default.comma(it.size)),
                        React.createElement("div", { className: "c-propsmsimilar__sizeunit" }, it.sizeUnit)),
                    React.createElement("div", { className: "c-propsmsimilar__sizegroup" },
                        React.createElement("div", { className: "c-propsmsimilar__sizevalue" }, format_1.default.comma(it.bed)),
                        React.createElement("div", { className: "c-propsmsimilar__sizeunit" }, props.t.bd)),
                    React.createElement("div", { className: "c-propsmsimilar__sizegroup" },
                        React.createElement("div", { className: "c-propsmsimilar__sizevalue" }, format_1.default.comma(it.bath)),
                        React.createElement("div", { className: "c-propsmsimilar__sizeunit" }, props.t.ba))))));
    };
    var renderPropertyItems = function (props) {
        if (!props.nearbyMap.big.properties)
            return;
        return props.nearbyMap.big.properties.map(renderPropertyItem);
    };
    return props.nearbyMap.big.properties.length ? (React.createElement("div", { className: "c-propsmsimilar__items c-propsmsimilar__items--sm" }, renderPropertyItems(props))) : (React.createElement("div", { className: "c-distance-card__empty c-distance-card__empty--sm" },
        React.createElement("div", { className: "c-distance-card__empty-title" }, props.t.noResults)));
};
exports.renderNearbyProperties = renderNearbyProperties;
